module.exports = __webpack_public_path__ + "img/DE05718.a478ff57.png";